import React from 'react';
import {
  generatePath,
  matchPath,
  RouteComponentProps,
  withRouter,
} from 'react-router';
import { getQuestionnaireByNameHook } from '../../../../apis/questionnaire';
import { getQuestionnaireResponseByReference } from '../../../../apis/questionnaireResponse';
import { PatientCristalCardComponent } from '../../../../components/Cards';
import { usePatient } from '../../../../contexts/patient';
import { IQuestionnaire } from '../../../../modules/unsw-fhir/Questionnaire';
import { IQuestionnaireResponse } from '../../../../modules/unsw-fhir/QuestionnaireResponse';
import {
  isIntegerAnswerComponent,
  isQuestionnaireResponseItemAnswer,
} from '../../../../modules/unsw-fhir/QuestionnaireResponse/typeGuards';
import { useDataApi } from '../../../../modules/unsw-hooks';

const CristalCard = (props: RouteComponentProps<{}>) => {
  const { patient, isActive } = usePatient();
  const patientId = patient && patient.id;

  const match = matchPath<{ organizationId: string; patientId: string }>(
    props.location.pathname,
    {
      path: '/organization/:organizationId/patient/:patientId',
    },
  );

  const organizationId = match ? match.params.organizationId : undefined;
  const [{ data: questionnaire, isLoading: isQuestionnaireLoading }] =
    useDataApi<IQuestionnaire | undefined>(
      getQuestionnaireByNameHook,
      undefined,
      'cristal',
    );

  const [
    { data: questionnaireResponse, isLoading: isQuestionnaireResponseLoading },
  ] = useDataApi<IQuestionnaireResponse | undefined>(
    getQuestionnaireResponseByReference,
    undefined,
    patientId,
    questionnaire ? questionnaire.id : undefined,
  );

  const params = {
    patientId: patientId!,
    organizationId: organizationId!,
    questionnaireResponseId: questionnaireResponse?.id!,
  };

  const viewPath = questionnaireResponse
    ? generatePath(
        '/organization/:organizationId/patient/:patientId/questionnaireResponse/:questionnaireResponseId',
        params,
      )
    : undefined;
  const editPath = questionnaireResponse
    ? generatePath(
        '/organization/:organizationId/patient/:patientId/questionnaireResponse/:questionnaireResponseId/edit',
        params,
      )
    : undefined;
  const newPath = patientId
    ? generatePath(
        '/organization/:organizationId/patient/:patientId/newQuestionnaireResponse/cristal',
        params,
      )
    : undefined;
  let score = '-';
  if (questionnaireResponse) {
    const item = questionnaireResponse.item.find(i => i.linkId === '8-0');

    if (item && isQuestionnaireResponseItemAnswer(item)) {
      const answer = item.answer[0];
      score =
        answer && isIntegerAnswerComponent(answer)
          ? answer.valueInteger.toString()
          : '-';
    }
  }
  return (
    <PatientCristalCardComponent
      created={questionnaireResponse && questionnaireResponse.authored}
      viewPath={viewPath}
      editPath={editPath}
      newPath={newPath}
      score={score}
      loading={isQuestionnaireLoading || isQuestionnaireResponseLoading}
      disabled={!isActive()}
    />
  );
};

export default withRouter(CristalCard);
